import {Component, h} from 'preact'
import {HomepageElement} from '../homepage'
import {Hero} from '../hero'
import {HTMLWidget} from '../html-widget/HTMLWidget'
import {KnowledgeBaseHomepageManager} from '../knowledge-base/control/KnowledgeBaseHomepageManager'
import {QuickLinksManager} from '../quick-links/QuickLinksManager'
import {TabsConfigurator} from '../homepage-tabs/TabsConfigurator'
import {FeaturedTopics} from '../featured-topics/FeaturedTopics'
import {Modal} from '../modal/Modal'
import Portal from 'preact-portal'
import TextButton from '../ui-components/TextButton'
import Icon from '../assets'
import Button from '../ui-components/Button'
import {HomepageContentCurationManager} from '../content-curation/HomepageContentCurationManager'

type TypeConfigElement = Pick<HomepageElement, 'type' | 'config' | 'title'>

interface Props {
  homepageElement: HomepageElement
  onChange: (config: TypeConfigElement) => void
  onClose: () => void
}

interface State {
  edit: boolean
}


export default class WidgetConfigurator extends Component<Props, State> {
  newConfig: TypeConfigElement

  constructor (props: Props) {
    super()
    this.newConfig = {
      type: props.homepageElement.type,
      config: props.homepageElement.config,
    }
  }

  async done () {
    this.props.onChange(this.newConfig)
  }

  getComponent (): JSX.Element | null {
    const el = this.props.homepageElement
    switch (el.type) {
      case 'hero_banner':
        return <Hero onChange={(config) => {
            this.newConfig = {
              type: el.type,
              config: {
                heroImage: config.hero_image,
                headline: config.headline
              }
            }
          }} heroImage={el.config.heroImage} headline={el.config.headline} />
      case 'html_widget':
        return <HTMLWidget content={el.config.html} deleteButtonAction={() => {}} onChange={config => {
        this.newConfig = {config, type: el.type}
      }} hideDeleteButton />
      case 'knowledge_base':
        return <KnowledgeBaseHomepageManager
          title={el.title}
          skipLoading
          onChange={config => {
            this.newConfig = {
              type: el.type,
              title: config.title,
              config: {title: config.title}
            }
          }}
        />
      case 'quick_links':
        return <QuickLinksManager
          isActive
          onChange={config => {
            this.newConfig = {
              type: el.type,
              title: config.title,
              config: {
                quickLinks: config.quickLinks.map(link => ({
                  ...link,
                  iconSrc: link.iconSrc,
                  imageSrc: link.imageSrc,
                  openNewTab: link.openNewTab
                })),
                enableBorder: config.settings.enableBorder,
                borderRadius: config.settings.borderRadius
              }
            }
          }}
          title={el.title}
          quickLinks={el.config.quickLinks.map(link => ({
            ...link,
            icon_src: link.iconSrc,
            image_src: link.imageSrc,
            target: link.openNewTab
          }))}
          settings={{
            borderRadius: el.config.borderRadius,
            enableBorder: el.config.enableBorder,
          }}
        />
      case 'category_and_topics_stream':
        return <TabsConfigurator
          tabs={el.config.tabs}
          class='tabs-configurator--wide'
          onChange={config => {
            this.newConfig = {
              type: el.type,
              config: { tabs: config.tabs }
            }
          }}
        />
      case 'recommendations':
        return <HomepageContentCurationManager
          curatedTopics={el.config.curatedTopics}
          title={el.title}
          onChange={config => {
            this.newConfig = {
              type: el.type,
              title: config.title,
              config: { curatedTopics: config.curatedTopics }
            }
          }}
        />
      case 'featured_topics':
        return <FeaturedTopics
          title={el.title}
          content={el.config}
          onChange={config => {
            this.newConfig = {
              type: el.type,
              title: config.title,
              config: {
                topics: config.topics,
                firstTopicsNumber: config.firstTopicsNumber,
                buttonLabel: config.buttonLabel,
                buttonURL: config.buttonURL
              }
            }
          }}
        />
      default:
        return null
    }
  }

  render () {
    return <Portal into='body'>
      <Modal size='fullscreen' isOpen>
        <div class='box__pad homepage-widget-configurator'>
          <div style={{textAlign: 'right'}}>
            <TextButton onClick={() => this.props.onClose()}>
              <Icon icon='close' />
            </TextButton>
          </div>
          <div class='homepage-widget-configurator__controls'>
            {this.getComponent()}
          </div>
          <div>
            <Button insided onClick={() => this.done()}>
              Done
            </Button>
          </div>
        </div>
      </Modal>
    </Portal>
  }
}
